<script setup>
import SiteHeader from '@/components/SiteHeader.vue'
import Globals from '@shared/model/Globals'

defineProps({
  title: { type: String, default: '404' },
  subtitle1: { type: String, default: 'Page not found' },
  subtitle2: { type: String, default: 'The page you are looking for does not exist.' },
  button: { type: String, default: 'Go to Home' }
})

function goToHomePage() {
  const referer = localStorage.getItem('referer')
  if (referer) {
    window.location.href = referer
  } else {
    window.location.href = Globals.HOME_URL
  }
}
</script>

<template>c
  <main class="isolate min-h-full">
    <div class="absolute inset-0 -z-10 size-full">
      <img :src="Globals.APP_SPLASH_URL" alt="" class="size-full object-cover object-top" />
      <div class="absolute inset-0 bg-gradient-to-b from-black/70 via-black/40 to-black/80"></div>
    </div>
    <div class="mx-auto max-w-7xl px-6 py-32 text-center sm:py-40 lg:px-8">
      <div class="mt-10 flex justify-center">
        <a href="#" @click.prevent="goToHomePage" class="text-sm/7 font-semibold text-white">
          <span aria-hidden="true">&larr; {{ button }}</span>
        </a>
      </div>
      <p class="text-base/8 font-semibold text-white">{{ title }}</p>
      <h1 class="mt-4 text-balance text-5xl font-semibold tracking-tight text-white sm:text-7xl">{{ subtitle1 }}</h1>
      <p class="mt-6 text-pretty text-lg font-medium text-white sm:text-xl/8">{{ subtitle2 }}</p>
    </div>
  </main>
</template>